// Kiểm tra xem mảng nhận vào có hợp lệ hay không
export const isInValidArray = (arr = []) => {
  if (!Array.isArray(arr) || arr.length === 0) return true
  return false
}
